/* This file is auto-generated. Do not modify it manually. */
export enum JwtCustomizerTypeDefinitionKey {
  JwtCustomizerUserContext = 'JwtCustomizerUserContext',
  AccessTokenPayload = 'AccessTokenPayload',
  ClientCredentialsPayload = 'ClientCredentialsPayload',
  EnvironmentVariables = 'EnvironmentVariables',
}

export const jwtCustomizerUserContextTypeDefinition = `type JwtCustomizerUserContext = {
    id: string;
    username: string | null;
    primaryEmail: string | null;
    primaryPhone: string | null;
    name: string | null;
    avatar: string | null;
    customData: {
        [x: string]: Record<string, unknown>;
    };
    identities: {
        [x: string]: {
            userId: string;
            details?: {
                [x: string]: Record<string, unknown>;
            } | undefined;
        };
    };
    lastSignInAt: number | null;
    createdAt: number;
    updatedAt: number;
    profile: {
        familyName?: string | undefined;
        givenName?: string | undefined;
        middleName?: string | undefined;
        nickname?: string | undefined;
        preferredUsername?: string | undefined;
        profile?: string | undefined;
        website?: string | undefined;
        gender?: string | undefined;
        birthdate?: string | undefined;
        zoneinfo?: string | undefined;
        locale?: string | undefined;
        address?: {
            formatted?: string | undefined;
            streetAddress?: string | undefined;
            locality?: string | undefined;
            region?: string | undefined;
            postalCode?: string | undefined;
            country?: string | undefined;
        } | undefined;
    };
    applicationId: string | null;
    isSuspended: boolean;
    hasPassword: boolean;
    ssoIdentities: {
        issuer: string;
        identityId: string;
        detail: {
            [x: string]: Record<string, unknown>;
        };
    }[];
    mfaVerificationFactors: ("Totp" | "WebAuthn" | "BackupCode")[];
    roles: {
        id: string;
        name: string;
        description: string;
        scopes: {
            id: string;
            name: string;
            description: string | null;
            resourceId: string;
            resource: {
                tenantId: string;
                id: string;
                name: string;
                indicator: string;
                isDefault: boolean;
                accessTokenTtl: number;
            };
        }[];
    }[];
    organizations: {
        id: string;
        name: string;
        description: string | null;
    }[];
    organizationRoles: {
        organizationId: string;
        roleId: string;
        roleName: string;
    }[];
};`;

export const accessTokenPayloadTypeDefinition = `type AccessTokenPayload = {
    jti: string;
    aud: string | string[];
    scope?: string | undefined;
    clientId?: string | undefined;
    accountId: string;
    expiresWithSession?: boolean | undefined;
    grantId: string;
    gty: string;
    sessionUid?: string | undefined;
    sid?: string | undefined;
    kind: "AccessToken";
};`;

export const clientCredentialsPayloadTypeDefinition = `type ClientCredentialsPayload = {
    jti: string;
    aud: string | string[];
    scope?: string | undefined;
    clientId?: string | undefined;
    kind: "ClientCredentials";
};`;
